export default __webpack_public_path__ + "static/media/LowerOStopTrimmed.1f8d5252.mp3";